import {
  Cable,
  CircleHelp,
  HardHat,
  Percent,
  Phone,
  Plus,
  RadioTower,
  Repeat,
  Satellite,
  ShieldCheck,
  Signal,
  Tv,
  Wifi,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import type {
  InternetConnectionType,
  InternetExtraType,
  InternetInstallationMethod,
} from "@/lib/fetch/internet";

export const INTERNET_CONNECTION_ICONS: Record<
  InternetConnectionType,
  LucideIcon
> = {
  FTTH: Cable,
  CABLE: Tv,
  DSL: Phone,
  FIXED_5G: RadioTower,
  FIXED_4G: Signal,
  SATELLITE: Satellite,
};

export const INTERNET_EXTRA_ICONS: Record<InternetExtraType, LucideIcon> = {
  TV: Tv,
  PHONE: Phone,
  MESH: Wifi,
  SECURITY: ShieldCheck,
  BUNDLE_DISCOUNT: Percent,
  OTHER: Plus,
};

export const INTERNET_INSTALLATION_ICONS: Record<
  InternetInstallationMethod,
  LucideIcon
> = {
  SELF: Wrench,
  TECHNICIAN: HardHat,
  EITHER: Repeat,
  CONDITIONAL: CircleHelp,
  UNKNOWN: CircleHelp,
};

/** Connection types shown as hub tiles and filter chips, most common first. */
export const INTERNET_FEATURED_CONNECTION_TYPES: readonly InternetConnectionType[] =
  ["FTTH", "CABLE", "DSL", "FIXED_5G", "SATELLITE"];
